import { Component, OnInit, ElementRef, Inject } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ProjectsService } from '../../services/projects-proposals-service/projects-proposals.service';
import { IFLDocuments } from '../../documents-cercador/documents.interfaces';

@Component({
  selector: 'dialog-documents',
  templateUrl: 'dialog.component.documents.html',
  styleUrls: ['dialog.component.documents.css'],
  providers: [ProjectsService]
})
export class DialogDocuments {
  public document: IFLDocuments = {'id': 0, 'titol': '', 'descripcio': '', 'tipus': '', 'data_doc': '', 'fitxer': '', 'file': null};
  public editDocumentData = Object.assign(this.document);

  constructor(public translate: TranslateService, public languageService: LanguageService, protected dataService: ProjectsService, public dialogRef: MatDialogRef<DialogDocuments>, @Inject(MAT_DIALOG_DATA) public data: any){
    this.editDocumentData =  data;
  }

  public onFileChange(event) {
    let reader = new FileReader();
    if(event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        if(file.size > 100000000){
          alert("Limit del fitxer a pujar 100Mb!");
          this.editDocumentData.fitxer = '';
          return;
        };
        this.editDocumentData.fitxer = file.name;
        this.editDocumentData.file = {
          filename: file.name,
          filetype: file.type,
          value: reader.result
        };
      };
    }else {this.editDocumentData.fitxer = null;this.editDocumentData.fitxer = '';}
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    this.dialogRef.close(this.editDocumentData);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  ngOnInit(){ }

}